import { emptyCategory } from 'repositories/category/CategoryRepository';

export const SORT_TYPE = Object.freeze({
  ACCURACY: 'ACCURACY',
  UPDATE: 'UPDATE',
  POPULAR: 'POPULAR',
});

export type T_SORT_TYPE = keyof typeof SORT_TYPE;

export const PRODUCT_TYPE = Object.freeze({
  DEFAULT: emptyCategory,
});

export const PERIOD_TYPE = Object.freeze({
  DEFAULT: 'DEFAULT',
  WEEK: 'WEEK',
  ONEMONTH: 'ONEMONTH',
  SIXMONTH: 'SIXMONTH',
  YEAR: 'YEAR',
});

export type T_PERIOD_TYPE = keyof typeof PERIOD_TYPE;

export const SRCH_DOC_TYPE = Object.freeze({
  DEFAULT: 'DEFAULT',
  APPLICATION_NOTE: 'APPLICATION_NOTE',
  TECHNICAL_GUIDE: 'TECHNICAL_GUIDE',
  TROUBLE_SHOOTING_KNW: 'TROUBLE_SHOOTING_KNW',
  SAMPLE: 'SAMPLE',
  TECH_GENERAL: 'TECH_GENERAL',
  MANUAL: 'MANUAL',
  CATALOG: 'CATALOG',
  EDUCATION_VIDEO: 'EDUCATION_VIDEO',
  EDUCATION_NOTE: 'EDUCATION_NOTE',
  EDUCATION_INTERNAL: 'EDUCATION_INTERNAL',
  QNA: 'QNA',
  //TIP: 'TIP',
  DOC_EVT: 'DOC_EVT',
  DOC_NOTI: 'DOC_NOTI',
  //JOB_OFFER: 'JOB_OFFER',
  //JOB_SEARCH: 'JOB_SEARCH',
  SOFTWARE: 'SOFTWARE',
  OS: 'OS',
  CAD_DATA: 'CAD_DATA',
  CERTIFICATION: 'CERTIFICATION',
  DATASHEET: 'DATASHEET',
  //SW_SERVICE: 'SW_SERVICE',
  //TROUBLE_SHOOTING: 'TROUBLE_SHOOTING',
  MARKETING_MATERIAL: 'MARKETING_MATERIAL',
  RND_TALK: 'RND_TALK',
  RND_NOTI: 'RND_NOTI',
  RND_QNA: 'RND_QNA',
});

export type T_SRCH_DOC_TYPE = keyof typeof SRCH_DOC_TYPE;

export const RANGE_TYPE = Object.freeze({
  DEFAULT: 'DEFAULT',
  LS_RELATED: 'LS_RELATED',
  LS_OFFICIAL: 'LS_OFFICIAL',
});

export const RESULT_TYPE = Object.freeze({
  ALL_RESULTS: 'ALL_RESULTS',
  VERBATIM: 'VERBATIM',
});
